import localStore from 'store'
import updatePlugin from 'store/plugins/update'

localStore.addPlugin(updatePlugin)

if(typeof localStore.get('data') === 'undefined'){
    localStore.set('data', null)
}

const initialState = {
    data: localStore.get('data')
}

const userReducer = (state = initialState, action) => {
    if (action.type === 'USER_LOGGED_IN'){
        localStore.set('data', action.payload)
        return Object.assign({}, state, {
            data: action.payload
        })
    }
  
    if (action.type === 'INIT_BALANCE'){
        localStore.update('data', function(data) {
            data.addressBalance = action.payload
        })
        return Object.assign({}, state, {
            data: {
                keystore: state.data.keystore,
                addressBalance: action.payload
            }
        })
    }

    if (action.type === 'USER_LOGGED_OUT'){
        localStore.set('data', null)
        return Object.assign({}, state, {
            data: null
        })
    }

    return state
}

export default userReducer



// WEBPACK FOOTER //
// ./src/user/userReducer.js